<template>
  <button type="button" class="toolbarBtn"
    :class="{active: active}"
    @mousedown.prevent
    @click.stop="onClick">
    <img src="~@/assets/img/CITEditor/underline.svg" alt="underline" title="underline" />
  </button>
</template>

<script>
export default {
  name: 'Underline',
  props: [
    'active',
    'tag'
  ],
  methods: {
    onClick () {
      document.execCommand('Underline', false)
      setTimeout(() => {
        const active = this.checkTag()
        this.$emit('setActive', { name: 'Underline', active: active })
      })
    },
    checkTag () {
      const selection = window.getSelection()
      const nodeName = selection.focusNode.parentNode.nodeName.toLowerCase()
      const isActive = this.tag.includes(nodeName)
      return isActive
    }
  }
}
</script>
